import { FC, useContext } from 'react'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormGenerator, ModalWrapper } from '@microservices/wiskey-react-components'
import { Box } from '@mui/material'

import { AutocompleteOption } from '@types'

import { SearchAssistantsCreateOrEditContext } from '../../SearchAssistantsCreateOrEdit'
import { SearchFilterValue } from '../../types/types'

import { useAddSearchFilterDialog } from './hooks'
import { SearchFilterValueFormInputs } from './SearchFilterValueFormInputs'

export type SearchFilterForm = {
  id?: number
  code: string
  title: string
  objectTitle: string
  objectCode?: string
  object: AutocompleteOption | null
  isPinning: boolean
  values: SearchFilterValue[]
  visibility: boolean
}

type AddSearchFilterDialogProps = {
  isEdit?: boolean
}

export const AddSearchFilterDialog: FC<AddSearchFilterDialogProps> = ({ isEdit }) => {
  const { t } = useTranslation()

  const { isDirty, handleSave, methods, searchFilterInputs } = useAddSearchFilterDialog()

  const { showAddSearchFilterModal, closeAddSearchFilterModal, isLoadingRow, isCriteriaLoading } =
    useContext(SearchAssistantsCreateOrEditContext)

  return (
    <ModalWrapper
      disabledSave={!isDirty || isCriteriaLoading}
      isShow={showAddSearchFilterModal}
      loading={isLoadingRow}
      title={t(`searchFilterForm.formTitle.${isEdit ? 'edit' : 'new'}`)}
      containerStyle={{
        px: 0.5,
        py: 0.5,
        // borderRadius: 0
      }}
      onClose={() => closeAddSearchFilterModal(isDirty)}
      onSave={handleSave}
    >
      <Box pb={2} pt={2} sx={{ maxHeight: 500, overflowY: 'auto', pr: 2 }}>
        <FormProvider {...methods}>
          <form>
            <FormGenerator inputs={searchFilterInputs} mainGridSpacing={0} />
            <SearchFilterValueFormInputs />
          </form>
        </FormProvider>
      </Box>
    </ModalWrapper>
  )
}
